import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { ExternalLink } from "components/common";
import { Checkbox, Col, FormGroup, HelpBlock, Row, Input } from "components/bootstrap";
import * as FormsUtils from "util/FormsUtils";
import TemplateFieldValueProviderPreview from "./TemplateFieldValueProviderPreview";
const _TemplateFieldValueProviderForm = class _TemplateFieldValueProviderForm extends React.Component {
  constructor() {
    super(...arguments);
    this.handleChange = (event) => {
      const { config, onChange } = this.props;
      const { name } = event.target;
      const value = FormsUtils.getValueFromInput(event.target);
      const nextProviders = cloneDeep(config.providers);
      const templateProvider = nextProviders.find((provider) => provider.type === _TemplateFieldValueProviderForm.type);
      templateProvider[name] = value;
      if (name === "require_values" && value) {
        templateProvider.exclude_empty_fields = true;
      }
      onChange({ ...config, providers: nextProviders });
    };
  }
  render() {
    var _a;
    const { config, validation } = this.props;
    const provider = config.providers.find((p) => p.type === _TemplateFieldValueProviderForm.type);
    const helpText = /* @__PURE__ */ React.createElement("span", null, "Type a literal text to set to this Field or use", " ", /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://cdn.rawgit.com/DJCordhose/jmte/master/doc/index.html" }, "JMTE syntax"), " to add a dynamic Value.");
    return /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 7, lg: 6 }, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "template-provider-template",
        name: "template",
        type: "text",
        label: "Template",
        onChange: this.handleChange,
        value: provider.template || "",
        bsStyle: validation.errors.template ? "error" : null,
        help: validation.errors.template || helpText
      }
    ), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
      Checkbox,
      {
        id: "lookup-message-require-values",
        name: "require_values",
        checked: provider.require_values,
        onChange: this.handleChange
      },
      "Require all template values to be set"
    ), /* @__PURE__ */ React.createElement(HelpBlock, null, "Check this option to validate that all variables used in the Template have values.")), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
      Checkbox,
      {
        id: "template-provider-exclude-empty-fields",
        name: "exclude_empty_fields",
        disabled: provider.require_values,
        checked: (_a = provider.exclude_empty_fields) != null ? _a : true,
        onChange: this.handleChange
      },
      "Exclude empty fields"
    ), /* @__PURE__ */ React.createElement(HelpBlock, null, "Check this option to leave the Field off the Event entirely when the Template renders an empty value. When unchecked, the Field is added to the Event with an empty value. Always on when all Template values are required."))), /* @__PURE__ */ React.createElement(Col, { md: 5, lgOffset: 1 }, /* @__PURE__ */ React.createElement(TemplateFieldValueProviderPreview, null)));
  }
};
_TemplateFieldValueProviderForm.type = "template-v1";
_TemplateFieldValueProviderForm.defaultConfig = {
  template: "",
  exclude_empty_fields: true
};
_TemplateFieldValueProviderForm.requiredFields = ["template"];
let TemplateFieldValueProviderForm = _TemplateFieldValueProviderForm;
export default TemplateFieldValueProviderForm;
